import useSWR from "swr";
import { adminUsersService } from "../../api_client";
import type { AdminUserQueryDto } from "../../../api";

export interface AdminUserListItem {
  id: string;
  name: string;
  email: string | null;
  phoneNumber: string | null;
  role: "admin" | "user";
  isActive: boolean;
  partnerId: number | null;
  createdAt: string;
}

interface AdminUsersResult {
  data: AdminUserListItem[];
  meta: { total: number; page: number; pageSize: number; pageCount: number };
}

export function useAdminUsers(query: AdminUserQueryDto = {}) {
  const cacheKey = `admin-users-${JSON.stringify(query)}`;

  const result = useSWR<AdminUsersResult>(cacheKey, async () => {
    const res = await adminUsersService.adminListUsers(query);
    return res.data as unknown as AdminUsersResult;
  }, {
    revalidateOnFocus: false,
    revalidateOnReconnect: false,
  });

  return {
    ...result,
    isLoading: result.isLoading ?? (!result.data && result.isValidating),
  };
}
